import React from 'react';
import classNames from 'classnames';
import { useThemeVarsClass } from '../../../../theme/provider';
import cn from './styles.module.scss';

export type NumberProgressProps = {
  current: number,
  total: number,
  label: string,
  href?: string,
};

export function NumberProgress({
  current, total, label, href,
}: NumberProgressProps) {
  const themeClassName = useThemeVarsClass();
  const content = (
    <div className={classNames(cn.container, themeClassName)}>
      <div className={cn.progress}>
        <span className={cn.current}>{current}</span>
        <span className={cn.total}>
          /
          {total}
        </span>
      </div>
      <span className={cn.label}>{label}</span>
    </div>
  );

  if (href) {
    return (
      <a href={href}>
        {content}
      </a>
    );
  }

  return content;
}
